import { render, staticRenderFns } from "./openingBlock.vue?vue&type=template&id=64e98b5a&scoped=true"
import script from "./openingBlock.vue?vue&type=script&lang=js"
export * from "./openingBlock.vue?vue&type=script&lang=js"
import style0 from "./openingBlock.vue?vue&type=style&index=0&id=64e98b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e98b5a",
  null
  
)

export default component.exports